/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: utils.ts
 * Class: utils.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { router } from './index';
import { Route } from 'vue-router';

export function getDateTimeFormatFromLocale(): string {
  try {
    return getLocalePrefixFromRoute().split('/')[0];
  } catch (error) {
    // @TODO: move this to .env when MR for enviroment support has been merged
    return 'de';
  }
}

/**
 * returns the region prefix from a supplied route OR it tries to automatically detect it
 * from the router module
 * @param route
 */
export function getRegionPrefixFromRoute(route: Route = null): string {
  const r: Route = route ?? router.currentRoute;

  if (!r.params || !('regionPrefix' in r.params) || !r.params.regionPrefix) {
    return undefined;
  }

  return r.params.regionPrefix;
}

export function getLocalePrefixFromRoute(): string {
  if ('localePrefix' in router.currentRoute.params
    && typeof router.currentRoute.params.localePrefix !== undefined) {
    // throw new Error('Could not find the active locale prefix from route!
    // Network requests may be doomed!');
    return router.currentRoute.params.localePrefix;
  }

  return undefined;
}
